import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const dhl = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "DHL Werkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>Willkommen bei der Werkstatt-Buchung von {{organization}}</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu dhl.de",
        navbar: {
          partnerLogo: {
            alt: "DHL",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/dhl",
      chooseSubServices: "Sollen weitere Services erledigt werden?",
      benefits: {
        ...de_DE_globalTranslations.translation.benefits,
        "bullet-point-3": "",
      },
    },
  },
};
